module.exports = __webpack_public_path__ + "img/w3_grid_dark.8c7c2d7c.png";